module.exports = __webpack_public_path__ + "media/images/about/about-2bd6521eaf463a3b2ddc370f9237e9ec.png";